export const userEndpoints = {
  list: '/users',
  create: '/users',
  update: (id: string) => `/users/${id}`,
} as const

export const USER_LIST_KEY = ['userList'] as const

// Backend `features/auth` (user) + `GeneralCrudErrors` kodları.
export const userBackendErrors = {
  GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  USER_NOT_FOUND: 'Kullanıcı bulunamadı.',
  AUTH_EMAIL_EXISTS: 'Bu e-posta zaten kayıtlı.',
} as const

export const userSuccessMessages = {
  userCreate: 'Kullanıcı başarıyla oluşturuldu!',
  userEdit: 'Kullanıcı başarıyla güncellendi!',
} as const
